const CLOUDINARY_HOST = "res.cloudinary.com";

export function centerCropCloudinaryUrl(url, { width, height } = {}) {
  if (!url || typeof url !== "string") {
    return "";
  }

  try {
    const parsed = new URL(url);

    if (parsed.hostname !== CLOUDINARY_HOST) {
      return url;
    }

    const uploadMarker = "/image/upload/";
    const uploadIndex = parsed.pathname.indexOf(uploadMarker);

    if (uploadIndex === -1) {
      return url;
    }

    const transformationParts = ["c_fill", "g_auto", "f_auto", "q_auto"];

    if (width) {
      transformationParts.push(`w_${Math.round(width)}`);
    }

    if (height) {
      transformationParts.push(`h_${Math.round(height)}`);
    }

    const transformation = transformationParts.join(",");
    const prefix = parsed.pathname.slice(0, uploadIndex + uploadMarker.length);
    const suffix = parsed.pathname.slice(uploadIndex + uploadMarker.length);

    parsed.pathname = `${prefix}${transformation}/${suffix}`;
    return parsed.toString();
  } catch {
    return url;
  }
}
